const getRatio = ({ width, height }) => parseFloat((width / height).toFixed(8));

export default getRatio;
